/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketPromoCodeDetail } from './TicketPromoCodeDetail';
import {
    TicketPromoCodeDetailFromJSON,
    TicketPromoCodeDetailFromJSONTyped,
    TicketPromoCodeDetailToJSON,
    TicketPromoCodeDetailToJSONTyped,
} from './TicketPromoCodeDetail';

/**
 * 
 * @export
 * @interface ResultOfTicketPromoCodeDetail
 */
export interface ResultOfTicketPromoCodeDetail {
    /**
     * 
     * @type {TicketPromoCodeDetail}
     * @memberof ResultOfTicketPromoCodeDetail
     */
    data: TicketPromoCodeDetail | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfTicketPromoCodeDetail
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfTicketPromoCodeDetail
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfTicketPromoCodeDetail interface.
 */
export function instanceOfResultOfTicketPromoCodeDetail(value: object): value is ResultOfTicketPromoCodeDetail {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfTicketPromoCodeDetailFromJSON(json: any): ResultOfTicketPromoCodeDetail {
    return ResultOfTicketPromoCodeDetailFromJSONTyped(json, false);
}

export function ResultOfTicketPromoCodeDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfTicketPromoCodeDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TicketPromoCodeDetailFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfTicketPromoCodeDetailToJSON(json: any): ResultOfTicketPromoCodeDetail {
    return ResultOfTicketPromoCodeDetailToJSONTyped(json, false);
}

export function ResultOfTicketPromoCodeDetailToJSONTyped(value?: ResultOfTicketPromoCodeDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TicketPromoCodeDetailToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

